module.exports = function() {
  return new Worker(__webpack_public_path__ + "5a44b96eede5866979ec.worker.js");
};